// Include jQuery
const $ = require('jquery');

// jQuery definitions
window.jQuery = $;
window.$ = $;

// Include Lightbox
import PhotoSwipeLightbox from 'photoswipe/lightbox';
// Caption Plugin für PhotoSwipe
import PhotoSwipeDynamicCaption from 'photoswipe-dynamic-caption-plugin';

// Include Vendors
require('./vendor/modernizr.touch');

// Include Helpers
require('./helper/accordion');
require('./helper/helper');
require('./helper/helperV2');
require('./helper/autocompleter');
require('./helper/contextMenu');
require('./helper/cookie');
require('./helper/pdfView');
require('./helper/uploader');

// Modules
require('./bienenwanderung/index');
require('./biopflanzmaterial/index');
require('./fotothek/fotothek');
require('./rundschreiben/index');
require('./meinSbr/index');
require('./wasserbilanz/index');

import Swiper from 'swiper';
import {Navigation, Autoplay} from 'swiper/modules';

import {TheZoomboxSbr} from './helper/the-zoombox-sbr';

window.theZoomboxInstances = [];

(function($) {
    /**
     * Ajax-Formulare
     * @param conf
     */
    $.fn.mpAjaxForm = function(conf) {
        $(this).find('form:first').submit(function() {
            const form = $(this);
            const ajaxForm = $(form).find('input[name=ajaxform]').val();

            // Formular per Ajax senden?
            if (ajaxForm > 0 && $(form).attr('enctype') !== 'multipart/form-data') {
                $(form).find('input[name=ajaxform]').attr('name', 'ajax_form');
                const form_data = $(this).find('input:not([type=checkbox],[type=radio],[type=submit],[type=image],[type=reset]), input[type=checkbox]:checked, input[type=radio]:checked, textarea, select').serialize();

                $.ajax({
                    url: form.attr('action'),
                    type: form.attr('method'),
                    data: form_data,
                    success: function(html) {
                        const cAjaxForm = $('#c' + ajaxForm);

                        cAjaxForm.replaceWith(html);
                        cAjaxForm.mpAjaxForm(conf);

                        const formTop = cAjaxForm.offset().top;
                        if ($(window).scrollTop() > formTop) {
                            $('html,body').animate({scrollTop: formTop}, 500);
                        }
                    },
                });
                return false;
            }
        });
    };
})($);

$(window).on('load', function() {
    if (location.hash !== '' && $(location.hash).length > 0) {
        $('html,body').animate({scrollTop: $(location.hash).offset().top}, 500);
    }
});

$(window).bind('hashchange', function(e) {
    e.preventDefault();
    if (location.hash !== '' && $(location.hash).length > 0) {
        $('html,body').animate({scrollTop: $(location.hash).offset().top}, 500);
    }
});

// Document Ready
$(function() {
    // CSS-Klasse wechseln, wenn JS aktiviert ist (für Fallbacks)
    $('html:first').removeClass('no-js').addClass('js');

    // Photoswipe config
    const lightbox = new PhotoSwipeLightbox({
        gallery: '.pswp-gallery',
        children: '.pswp-gallery__item',
        pswpModule: () => import('photoswipe'),
        secondaryZoomLevel: 2,
        maxZoomLevel: 1,
        wheelToZoom: true,
    });
    // Photoswipe caption
    // eslint-disable-next-line
    new PhotoSwipeDynamicCaption(lightbox, {
        // Plugins options, for example:
        type: 'below',
        captionContent: (slide) => {
            // Caption aus figcaption ziehen
            return (slide.data.element.nextElementSibling ? slide.data.element.nextElementSibling.textContent : '');
        },
    });
    lightbox.init();

    /**
     * initStandardZoombox
     * @param container
     * @param target
     * @param options
     * @deprecated
     */
    function initStandardZoombox(container, target, options) {
        if (container) {
            // Elemente abrufen, die 'zoombox' haben, aber NICHT 'the-zoombox-initialized'
            const newZoomboxElements = container.querySelectorAll(target + ':not([data-zoombox-instance])');

            newZoomboxElements?.forEach((element) => {
                // Initialisieren Sie TheZoomboxSbr für den neuen Knoten
                const zoomboxInstanceID = crypto.randomUUID();
                element.dataset.zoomboxInstance = zoomboxInstanceID;
                theZoomboxInstances[zoomboxInstanceID] = new TheZoomboxSbr(element, {
                    zoomboxInstanceID: zoomboxInstanceID,
                    ...options,
                });
            });
        }
    }

    const defaultZoomboxOptions = {
        identifyBy: 'a:not(.pdf-modal)', sidebar: false, changeHistory: false, useLegacyCaption: true, useMaterialIcons: true,
    };

    initStandardZoombox(document.getElementById('layout'), '.zoombox', defaultZoomboxOptions);

    const rundschreibenFotothekListZoomboxOptions = {
        identifyBy: 'a.card',
        ajaxInfo: MP_PATH + 'sbr/fotothek/ajax/helper/ajax.getInfo',
        changeHistory: false,
        afterClose: function() {
            // Wurden Bilddaten geändert? Dann Liste aktualisieren
            if (typeof fotothekChanged !== 'undefined') {
                ListFotothek.updater();
                fotothekChanged = undefined;
            }
        },
    };
    initStandardZoombox(document.getElementById('layout'), '.rundschreiben-fotothek-list .card', rundschreibenFotothekListZoomboxOptions);

    const fotothekZoomboxOptions = {
        useLegacyCaption: true,
        useMaterialIcons: true,
        sidebar: true, // Stellen Sie sicher, dass Sie `sidebar: true` angeben
        ajaxInfo: 'ajax/helper/ajax.getInfo',
        afterClose: function() {
            // Wurden Bilddaten geändert? Dann Liste aktualisieren
            if (typeof fotothekChanged !== 'undefined') {
                ListFotothek.updater();
                fotothekChanged = undefined;
            }
        },
    };
    initStandardZoombox(document.getElementById('layout'), '#photo-list', fotothekZoomboxOptions);

    const mutationObserver = new MutationObserver((mutations) => {
        // Diese Funktion wird jedes Mal ausgeführt, wenn sich der DOM-Baum ändert
        mutations.forEach(() => {
            initStandardZoombox(document.getElementById('layout'), '.zoombox', defaultZoomboxOptions);
            initStandardZoombox(document.getElementById('layout'), '.rundschreiben-fotothek-list .card', rundschreibenFotothekListZoomboxOptions);
            initStandardZoombox(document.getElementById('layout'), '#photo-list', fotothekZoomboxOptions);
        });
    });

    if (document.getElementById('layout') && mutationObserver) {
        mutationObserver.observe(document.getElementById('layout'), {
            childList: true,
            subtree: true,
        });
    }

    // tooltip
    window.initTooltip();

    // clipboard
    window.initClipboard('.copyClipboard');

    // Init Password Toggle
    initPasswordToggle();

    // Check pw repeat
    checkPwRepeat();

    // PW Strength
    if (document.querySelectorAll('.check-pw-strength').length > 0) {
        document.querySelectorAll('.check-pw-strength').forEach(ele => {
            var elementID = ele.getAttribute('id');
            checkPwStrength('#verify-pw', elementID);

            const passwordInput = document.getElementById(elementID);
            passwordInput.addEventListener('keyup', function() {
                checkPwStrength('#verify-pw', elementID);
            });

            passwordInput.addEventListener('change', function() {
                checkPwStrength('#verify-pw', elementID);
            });
        });
    }

    // Search-Field with icon
    const searchField = $('.search-field');
    if (searchField.length > 0) {
        searchField.before('<i class="material-icons search-icon">close</i>');
    }

    const searchIcon = $('.search-icon');
    if (searchIcon.length > 0) {
        searchIcon.on('click', function() {
            const nextInput = $(this).next();
            nextInput.val('');
            nextInput.trigger('input');
        });
    }

    // Bypass-Menu Button
    $('.ce-frame__accessibility-bypass').click(function(e) {
        e.preventDefault();
        const wrap = $(this).closest('.ce-frame');
        const scrollheight = wrap.offset().top + wrap.height();
        $('html,body').animate({scrollTop: scrollheight}, 500);
    });

    $('.ce-login').mpAjaxForm();

    // Alle SVG's als inline SVG - für Farbanpassungen
    const svgElements = document.querySelectorAll('img.svg');
    if (svgElements) {
        svgElements.forEach(function(svgElement) {

            const imgID = svgElement.getAttribute('id');
            const imgClass = svgElement.getAttribute('class');
            const imgURL = svgElement.getAttribute('src');

            fetch(imgURL).then(response => response.text()).then(str => new window.DOMParser().parseFromString(str, 'text/xml')).then(data => {
                // Get the SVG tag, ignore the rest
                const svg = data.querySelector('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    svg.setAttribute('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    svg.setAttribute('class', imgClass);
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                svg.removeAttribute('xmlns:a');

                // Replace image with new SVG
                svgElement.replaceWith(svg);
            });

        });
    }

    // Höhe Header
    const navHeight = $('#header').outerHeight();

    // Höhe Menü mobile
    if (window.innerWidth < 1024) {
        $('#menu').css('height', 'calc(100vh - ' + navHeight + 'px)');
    }

    // Positionen Dropdown
    $('.dropdown').css('top', navHeight);

    // Bei Klick auf Overlay Dropdowns + Menü schließen
    const documentBody = document.body;
    documentBody.addEventListener('click', function(e) {
        const menuOverlay = document.querySelector('#menu-overlay');

        if (e.target.id === 'menu-overlay') {
            documentBody.classList.remove('dropdown-open');
            documentBody.classList.remove('menu-open');
            documentBody.classList.remove('search-open');

            if (menuOverlay) {
                menuOverlay.remove();
            }
        }
    });

    window.checkCookieNotice();

    // Matomo
    if (window.location.hostname === 'www3.beratungsring.org') {
        var _paq = window._paq = window._paq || [];
        /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
        _paq.push(['trackPageView']);
        _paq.push(['enableLinkTracking']);
        (function() {
            var u = 'https://matomo.beratungsring.org/';
            _paq.push(['setTrackerUrl', u + 'matomo.php']);
            _paq.push(['setSiteId', '2']);
            var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
            g.async = true;
            g.src = u + 'matomo.js';
            s.parentNode.insertBefore(g, s);
        })();
    }
});

// KeyDown
$(document).on('keydown', function(e) {
    if (e.key === 'Escape') {
        let popupWrap = [];
        $('body').find('.modal').each(function() {
            popupWrap.push($(this));
        });

        const lastItem = popupWrap.pop();

        // Beim Drücken von ESC das letzte Popup schließen
        if (typeof lastItem !== 'undefined' && lastItem.length) {
            if (typeof overwriteClose === 'function') {
                overwriteClose(); // eslint-disable-line
            }

            const popUpWrap = $('body .modal');
            popUpWrap.last().remove();
            if ($('body .modal ').length === 0) {
                $('body .modal-backdrop').remove();
            }

            window.checkOpenDialog();
            return false;
        }
    }
});

/**
 * Back to top Button Funktion
 */
const toTopButton = () => {
    let topButton = document.querySelector('.to-top-btn');
    if (topButton) {
        topButton.addEventListener('click', () => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    }
};

/**
 * telBtn
 */
function telBtn() {
    // Wenn Desktop
    let telButton = document.querySelector('#footer .btn-tel.desktop');

    // On Click bleibt die Nummer stehen
    if (telButton) {
        telButton.addEventListener('click', () => {
            telButton.classList.toggle('clicked');
        });
    }
}

const SliderSettings = {
    speed: [3000, 5000, 6000, 8000, 9000, 10000],
    height: [90, 25, 33, 50, 70],
};

/**
 * setActiveOnTeamMember
 */
function setActiveOnTeamMember() {

    // Get all elements with the class 'region-item' inside '#team-wrap'
    var items = document.querySelectorAll('#team-wrap .chip');

    // Loop through each item and attach a click event listener
    items.forEach(function(item) {
        item.addEventListener('click', function() {
            // Remove 'active' class from all items
            items.forEach(function(item) {
                item.classList.remove('active');
            });

            // Add 'active' class to the clicked item
            this.classList.add('active');
        });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    let sliderSpeed = 0;
    let sliderHeight = 0;
    if (document.getElementById('sliderSpeed')) {
        sliderSpeed = document.getElementById('sliderSpeed').value;
    }
    if (document.getElementById('sliderHeight')) {
        sliderHeight = document.getElementById('sliderHeight').value;
    }

    new Swiper('.swiper.js--cslider', {
        modules: [Navigation, Autoplay],
        direction: 'horizontal',
        loop: true,
        autoplay: {
            delay: SliderSettings.speed[sliderSpeed],
        },
        allowTouchMove: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    if (document.getElementsByClassName('js--cslider')[0] && SliderSettings.height[sliderHeight] !== null) {
        document.getElementsByClassName('js--cslider')[0].style.height = `${SliderSettings.height[sliderHeight]}vh`;
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function animateCounter(element, upperBound) {
        // Bereche Schrittweite damit dass Zählen in ca. 1sec abgeschlossen ist.
        let step = 1;
        while (upperBound / step > 1000) {
            step *= 10;
        }

        for (var i = 0; i <= upperBound; i += step) {
            // ausschlißelich Nummern
            // element.innerHTML = i.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.');
            element.innerHTML = i.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');

            await sleep(Math.ceil(1000 / upperBound));
        }

        element.innerHTML = upperBound.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
    }

    let animationPlayed = false;

    const counterContainerElements = document.querySelectorAll('.grid-counter-container .ce-container__col > .ce-frame header .ce-header__header');
    const counterContainerObserver = new IntersectionObserver(function(entries) {
        entries.forEach(async function(entry) {
            let upperBound = entry.target.innerHTML;
            if (upperBound.match(/\./)) {
                upperBound = upperBound.replaceAll(/\./g, '');
            }
            if (!animationPlayed && entry.isIntersecting && upperBound.match(/^[0-9]*/)[0] !== '') {
                await animateCounter(entry.target, upperBound);
                animationPlayed = true;
            }
        });
    });

    counterContainerElements.forEach(function(counterContainer) {
        counterContainerObserver.observe(counterContainer);
    });

    // Trigger the animation on page load if the element is initially in the viewport
    async function triggerAnimationOnLoad() {
        for (const counterContainer of counterContainerElements) {
            let upperBound = counterContainer.innerHTML;
            if (upperBound.match(/\./)) {
                upperBound = upperBound.replaceAll(/\./g, '');
            }
            if (!animationPlayed && upperBound.match(/^[0-9]*/)[0] !== '' && counterContainerObserver.isIntersecting) {
                await animateCounter(counterContainer, upperBound);
                animationPlayed = true;
            }
        }
    }

    // Captcha
    if (document.querySelector('.iconcaptcha-widget')) {
        // Check the README.md for information about the options.
        IconCaptcha.init('.iconcaptcha-widget', {
            general: {
                endpoint: BASE_PATH + 'ajax/helper/additional/captcha',
                fontFamily: 'inherit',
                credits: 'disabled',
            },
            security: {
                interactionDelay: 500,
                hoverProtection: true,
                displayInitialMessage: true,
                initializationDelay: 500,
                incorrectSelectionResetDelay: 3000,
                loadingAnimationDuration: 1000,
            },
            locale: {
                initialization: {
                    verify: LANG_STRINGS.CAPTCHA_VERIFIZIEREN,
                    loading: LANG_STRINGS.CAPTCHA_WIRD_GELADEN,
                },
                header: LANG_STRINGS.CAPTCHA_WAHLEN_SIE_DAS_BILD_AUS,
                correct: LANG_STRINGS.CAPTCHA_VERIFIZIERT,
                incorrect: {
                    title: LANG_STRINGS.CAPTCHA_FEHLER,
                    subtitle: LANG_STRINGS.CAPTCHA_FALSCHES_BILD_AUSGEWAEHLT,
                },
                timeout: {
                    title: LANG_STRINGS.CAPTCHA_15_SEKUNDEN_WARTEN,
                    subtitle: LANG_STRINGS.CAPTCHA_ZU_VIELE_FALSCHE_AUSWAHLEN,
                },
            },
        });
    }

    function menuHandling() {
        // Overlay für Dropdowns + Menu
        let menuOverlay = document.querySelector('#menu-overlay');

        // Menu Start__________________________________________________________________________________________________________
        const body = document.body;
        // Menü, Login-Menü, Sprachschaltung zusammengefasst
        const triggers = {
            'user': document.querySelector('#user'),
            'language-wrap': document.querySelector('#language-wrap'),
            'menu-button': document.querySelector('#menu-button'),
        };

        const dropdowns = {
            'user': document.querySelector('.dropdown--user'),
            'language-wrap': document.querySelector('#languages'),
            'menu-button': document.querySelector('#menu'),
        };

        function closeAllDropdowns() {
            Object.values(dropdowns).forEach(dropdown => {
                if (dropdown) {
                    dropdown.style.display = 'none';
                    dropdown.style.visibility = 'hidden';
                }
            });
            body.classList.remove('menu-open');
        }

        // Submenu Handling
        document.querySelectorAll('.submenu-open, .has-sub .seperator').forEach(function(element) {
            element.addEventListener('click', function(event) {
                event.stopPropagation(); // Prevent closing when clicking submenu items

                this.parentElement.parentElement.querySelectorAll('li.open').forEach(function(sibling) {
                    if (sibling !== element.closest('li')) {
                        sibling.classList.remove('open');
                    }
                });

                this.closest('li').classList.toggle('open');
                body.classList.toggle('sub-menu-open');

                return false;
            });
        });

        // JavaScript functionality for user button
        if (triggers['user']) {
            triggers['user'].addEventListener('click', function(e) {
                e.stopPropagation();

                const userButton = e.currentTarget;
                const userLink = userButton.getAttribute('data-link');
                if (userLink) {
                    window.location.href = userLink;
                    return;
                }

                const dropdown = dropdowns['user'];
                if (dropdown) {
                    if (dropdown.style.display === 'block') {
                        dropdown.style.display = 'none';
                        dropdown.style.visibility = 'hidden';
                        menuOverlay.style.display = 'none';
                        menuOverlay.style.visibility = 'hidden';
                    } else {
                        closeAllDropdowns();
                        dropdown.style.display = 'block';
                        dropdown.style.visibility = 'visible';
                    }
                }
            });
        }

        // Attach event listeners to other triggers
        Object.keys(triggers).forEach(key => {
            if (key !== 'user') { // Exclude user since it's handled separately
                if (triggers[key]) {
                    triggers[key].addEventListener('click', function(e) {
                        e.stopPropagation();

                        const dropdown = dropdowns[key];
                        if (dropdown.style.display === 'block') {
                            dropdown.style.display = 'none';
                            dropdown.style.visibility = 'hidden';
                            menuOverlay.style.display = 'none';
                            menuOverlay.style.visibility = 'hidden';
                            if (key === 'menu-button') {
                                body.classList.remove('menu-open');
                            }
                        } else {
                            closeAllDropdowns();
                            dropdown.style.display = 'block';
                            dropdown.style.visibility = 'visible';

                            if (key === 'menu-button') {
                                body.classList.toggle('menu-open');
                            }
                        }
                    });
                }
            }
        });

        document.addEventListener('click', function() {
            closeAllDropdowns();
        });

        // Prevent closing when clicking inside dropdowns
        if (Object.values(dropdowns)) {
            Object.values(dropdowns).forEach(dropdown => {
                if (dropdown) {
                    dropdown.addEventListener('click', function(e) {
                        e.stopPropagation();
                    });
                }
            });
        }
    }

    // Fake Select Beitragsjahre
  function initFakeSelects() {
    document.querySelectorAll('.fs__header').forEach((button, index) => {
      const list = button.nextElementSibling;
      const status = document.querySelector('#fake-select-accordion-status');

      // Assign unique IDs if missing
      const listboxId = `listbox-${index}`;
      const buttonId = `fake-select-${index}`;
      button.id = button.id || buttonId;
      list.id = list.id || listboxId;

      // Link button and listbox via ARIA
      button.setAttribute('aria-controls', list.id);

      const toggleList = (button, list) => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const newState = !expanded;

        button.setAttribute('aria-expanded', String(newState));
        list.classList.toggle('is-visible', newState);

        // Screenreader Ansage
        if (status) {
          status.textContent = newState ? 'Dropdown ausgeklappt' : 'Dropdown eingeklappt';
        }
      };

      const handleToggleEvent = (event) => {
        if (
            event.type === 'click' ||
            (event.type === 'keydown' && (event.key === 'Enter' || event.key === ' '))
        ) {
          event.preventDefault();
          toggleList(button, list);
        }
      };

      button.addEventListener('click', handleToggleEvent);
      button.addEventListener('keydown', handleToggleEvent);
    });
  }

// Call this once DOM is loaded

    // Funktionen aufrufen _______________________________________________________________________________________
    // telButton();
    telBtn();
    toTopButton();
    triggerAnimationOnLoad().then(); // Call the function to trigger the animation on page load
    setActiveOnTeamMember();
    iOSInputFix();
    window.statisticVideo(); // Statistic videos
    menuHandling();
    initFakeSelects();
});
